import React from 'react'
import PrefixContext from '../contexts/PrefixContext'

export default function usePrefix () {
  return React.useContext(PrefixContext)
}
